import { Breadcrumb, CardContainer, Container } from "components";
import React, { useCallback, useContext, useEffect, useState } from "react";
import uploadImage from "../../../assets/images/dashboard/uploadimage.png";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { agentReducers } from "redux/agentSlice";
import { getData, putData } from "actions";
import { API_URL_agent } from "constants/api";
import { useDispatch, useSelector } from "react-redux";
import { CKEditor } from "ckeditor4-react";
import { AuthContext } from "context/AuthContext";

const FormProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { datauser } = useContext(AuthContext);
  const { getAgentResult } = useSelector((state) => state.agent);
  const [imageUrl, setImageUrl] = useState(null);

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_agent,
        params,
        { dispatch, redux: agentReducers },
        "GET_AGENT"
      );
    },
    [dispatch]
  );

  const fetchData = useCallback(() => {
    //get id 1 for setting
    const params = `${datauser.id}/`;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  const formik = useFormik({
    initialValues: {
      first_name: getAgentResult ? getAgentResult.first_name : "",
      last_name: getAgentResult ? getAgentResult.last_name : "",
      gender: getAgentResult ? getAgentResult.gender : "",
      email: getAgentResult ? getAgentResult.email : "",
      company: getAgentResult ? getAgentResult.company : "",
      country_code: getAgentResult ? getAgentResult.country_code : "",
      mobile: getAgentResult ? getAgentResult.mobile : 0,
      ext: getAgentResult ? getAgentResult.ext : "",
      phone_number: getAgentResult ? getAgentResult.phone_number : 0,
      agent_sign: getAgentResult ? getAgentResult.agent_sign : "",
      profile_pic: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("First Name is required"),
      gender: Yup.string().required("Gender is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      formData.append("gender", values.gender);
      formData.append("email", values.email);
      formData.append("company", values.company);
      formData.append("country_code", values.country_code);
      formData.append("mobile", values.mobile);
      formData.append("ext", values.ext);
      formData.append("phone_number", values.phone_number);
      formData.append("agent_sign", values.agent_sign);

      if (formik.values.profile_pic !== "") {
        formData.append("profile_pic", formik.values.profile_pic);
      }

      putData(
        `${API_URL_agent}${datauser.id}/`,
        formData,
        { dispatch, redux: agentReducers },
        "ADD_AGENT",
        () => {
          setTimeout(() => {
            window.location.href = "/dashboard/profile/informationprofile";
          }, 2000);
        }
      );
    },
  });

  const handleChangeImage = (e) => {
    const file = e.target.files[0];
    formik.setFieldValue("profile_pic", file);
    setImageUrl(URL.createObjectURL(file)); // Menetapkan URL gambar ke imageUrl
  };

  const toolbarConfig = {
    extraPlugins: "font,colorbutton,colordialog",
    removePlugins: "about,image",
    skin: "moono",
  };
  useEffect(() => {
    if (getAgentResult === false) {
      navigate("/");
    }
  }, []);

  return (
    <Container>
      <Breadcrumb
        title={"Form Profile"}
        excludedPaths={["profile", "dashboard"]}
      />
      <CardContainer title={"Edit Profile"}>
        <form onSubmit={formik.handleSubmit}>
          <div className="m-5">
            <div className="grid grid-cols-12 grid-flow-row mb-4 gap-4">
              <div className=" col-span-12 md:col-span-6">
                <div className="grid grid-cols-12">
                  <label className="col-span-12 font-bold">
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="first_name"
                    name="first_name"
                    value={formik.values.first_name}
                    onChange={formik.handleChange}
                    type="text"
                    className="p-1 w-full col-span-12 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                  />
                  {formik.touched.first_name && formik.errors.first_name && (
                    <div className="text-red-500 dark:text-red-300 text-xs">
                      {formik.errors.first_name}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-span-12 md:col-span-6">
                <div className="grid grid-rows-12">
                  <label className="col-span-12 font-bold">Last Name</label>
                  <input
                    id="last_name"
                    name="last_name"
                    value={formik.values.last_name}
                    onChange={formik.handleChange}
                    type="text"
                    className="p-1 w-full col-span-12 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 grid-flow-row mb-4 gap-4">
              <div className=" col-span-12 md:col-span-6">
                <div className="grid grid-cols-12">
                  <label className="col-span-12 font-bold">Gender</label>
                  <div className="flex">
                    <div className="mr-10">
                      <label>
                        Male
                        <input
                          type="radio"
                          id="gender"
                          name="gender"
                          checked={formik.values.gender === 1}
                          onChange={(e) => formik.setFieldValue("gender", 1)}
                          className="mr-2"
                        />
                      </label>
                    </div>
                    <label>
                      Female
                      <input
                        type="radio"
                        id="gender"
                        name="gender"
                        checked={formik.values.gender === 0}
                        onChange={(e) => formik.setFieldValue("gender", 0)}
                        className="mr-2"
                      />
                    </label>
                  </div>
                </div>
                {formik.touched.gender && formik.errors.gender && (
                  <div className="text-red-500 dark:text-red-300 text-xs">
                    {formik.errors.gender}
                  </div>
                )}
              </div>
              <div className="col-span-12 md:col-span-6">
                <div className="grid grid-rows-12">
                  <label className="col-span-12 font-bold">Email Addres</label>
                  <input
                    id="email"
                    value={formik.values.email}
                    type="email"
                    disabled={true}
                    className="p-1 w-full col-span-12 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 grid-flow-row mb-4 gap-4">
              <div className="col-span-12 md:col-span-12">
                <div className="grid grid-rows-12">
                  <label className="col-span-12 font-bold">Number Phone</label>
                  <input
                    id="phone_number"
                    name="phone_number"
                    value={formik.values.phone_number}
                    onChange={formik.handleChange}
                    type="number"
                    className="p-1 w-full col-span-12 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 mb-4">
              <label className="col-span-12 font-bold block">
                Agent Signature
                <CKEditor
                  config={toolbarConfig}
                  type="classic"
                  initData={formik.values.agent_sign}
                  onChange={(e) => {
                    formik.setFieldValue("agent_sign", e.editor.getData());
                  }}
                />
              </label>
            </div>
            <div>
              <label className="font-bold block">Profile Image</label>
              <input
                type="file"
                id="profile_pic"
                name="profile_pic"
                onChange={handleChangeImage} // Menggunakan handleChangeImage langsung tanpa pemanggilan berulang
              />
              {imageUrl ? (
                <img
                  src={imageUrl} // Gunakan imageUrl untuk menampilkan gambar yang dipilih
                  alt="Selected"
                  className="h-44 mt-2 border-2 border-dotted border-sky-500"
                />
              ) : (
                <img
                  src={uploadImage}
                  alt="Selected"
                  className="h-44 mt-2 border-2 border-dotted border-sky-500"
                />
              )}
            </div>
          </div>
          <div className="h-14 w-full flex items-center px-5 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="rounded-md text-white py-1.5 w-32 bg-sky-700 hover:bg-sky-800 "
            >
              Submit
            </button>
          </div>
        </form>
      </CardContainer>
    </Container>
  );
};

export default FormProfile;
